<template v-if="loaded">
    <a rel="noopener noreferrer" :title="title" class="share-widget__link share-widget__clipboard" :class="[{ 'active': this.active}]" href="#" @click="onClick">
        <Icon name="link" /><span class="share-widget__clipboard-label">{{  label }}</span>
    </a>
</template>

<script>
import Icon from './Icon.vue';

export default {
    name: 'ClipboardLink',
    data() {
        return {
            active: false,
            loaded: false,
        };
    },
    props: ['url', 'title', 'label'],
    mounted: function() {
        this.loaded = true;
    },
    components: {
        Icon
    },
    methods: {
        onClick(event) {
            event.preventDefault();

            const element = event.target;
		
            navigator.clipboard.writeText(this.url);
            this.active = true;

            setTimeout(() => {
                this.active = false;
                element.blur();
            }, '1500');
        }
    }
};
</script>